module.exports = ".main-menu .collapse {\n  display: block;\n}\n\n.mini-sidebar .logo span {\n  display: none;\n}\n\n.mini-sidebar .sidebar, .mini-sidebar .slimScrollDiv {\n  overflow: visible !important;\n}\n\n.mini-sidebar .scroll-sidebar {\n  overflow-x: visible !important;\n  overflow-y: hidden !important;\n}\n\n.right-sidebar {\n  display: block;\n}\n\n.mini-sidebar .sidebar-nav {\n  background: 0 0;\n}\n\n\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/layout/admin/admin-layout.component.css
// module id = ./src/app/layout/admin/admin-layout.component.css
// module chunks = main